import MuiMenuItem from '@zenbusiness/zui/MenuItem';
import { styled } from '@zenbusiness/zui/styles';

const MenuItemStyle = ({ theme, selected, isBold }) => ({
  '&.MuiButtonBase-root': {
    padding: '8px 32px',
    [theme.breakpoints.up('md')]: {
      padding: '8px 24px'
    },
    backgroundColor: selected ? theme.palette.background.cyan.main : 'transparent !important'
  },
  '&.Mui-selected': {
    fontWeight: 600
  },
  '&:hover': {
    backgroundColor: 'rgba(207, 249, 250, 0.4)'
  },
  '&:first-of-type': {
    fontWeight: isBold ? 600 : 'initial'
  }
});

export const MenuItem = styled(MuiMenuItem, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'isBold'
})(MenuItemStyle);
